import _ from 'lodash';
import { store, history } from 'index';
import { setSteps } from 'redux/actions/steps';
import { getAccount } from '../actions/account';


class Steps {
  constructor() {
    _.bindAll(this, ['handleAccountRequest']);
  }

  init() {
    this.isGet = false;
    this.isRequest = true;

    return store.dispatch(getAccount()).then(
      this.handleAccountRequest,
      this.handleAccountRequest,
    );
  }

  handleAccountRequest(res) {
    this.isGet = true;
    this.isRequest = false;

    if (res.status === 401 || !res.data) {
      store.dispatch(setSteps());
      return;
    }

    store.dispatch(setSteps(res.data));
  }

  setStep(step) {
    this.step = step;
    this.conditionStep();
  }

  conditionStep() {
    if (this.step > 1) {
      if (window.location.pathname === '/dashboard') return;
      history.replace('/dashboard');
    } else {
      if (window.location.pathname === '/steps') return;
      history.replace('/steps', { isState: true });
    }
  }

  /**
   *  Set steps from server
   *  @param {object} res - dictionary arrays
   * */
  setSteps(account) {
    if (!account) return;

    let stepCounter = 0;

    this.state = {
      crms: account.crms || [],
      ad_networks: account.ad_networks || [],
    };

    if (this.state.crms.length !== 0) stepCounter++;
    // if (this.state.ad_networks.length !== 0) stepCounter++;
    if (account && account.billable && stepCounter > 0) stepCounter++;

    this.setStep(stepCounter);
  }

  /**
   *  Add crms system
   *  @param {string} crm - name adding crm
   * */
  addCrm(crm) {
    if (this.state.crms.includes(crm)) return;
    this.state.crms.push(crm);
  }

  /**
   *  Add advertising from front
   *  @param {string} ad - name adding advertising
   * */
  addAdvertising(ad) {
    if (this.state.ad_networks.includes(ad)) return;
    this.state.ad_networks.push(ad);
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/redux/models/Steps.js